import React from "react";

import { SubHeading } from "../../components";
import { images } from "../../constants";

const FindUs = () => {
  const address = "6424 Northwest Loop 410 #104, San Antonio, TX 78238";
  const encodedAddress = encodeURIComponent(address);
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  return (
    <div className="app__bg app__wrapper section__padding" id="contact">
      <div className="app__wrapper_info">
        <SubHeading title="Order Pickup" />
        <h1 className="headtext__cormorant" style={{ marginBottom: "3rem" }}>
          Find Us
        </h1>
        <div className="app__wrapper-content">
          <p className="p__opensans">{address}</p>
          <p className="p__opensans">Phone: (210) 354-7547</p>
          <p
            className="p__cormorant"
            style={{ color: "#DCCA87", margin: "2rem 0" }}
          >
            Opening Hours
          </p>
          <p className="p__opensans">Tuesday - Sunday, Open 6 Days A Week</p>
          <p className="p__opensans">11AM - 8PM</p>
        </div>
        <a
          href={mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="custom__button"
          style={{ marginTop: "2rem", textDecoration: "none" }}
        >
          Visit Us
        </a>
      </div>

      <div className="app__wrapper_img">
        <img src={images.findus} alt="find us location" />
      </div>
    </div>
  );
};

export default FindUs;
